
import markdown from 'spa-ionata-admin/lib/services/markdown';
import { Component, Vue, Prop } from 'vue-property-decorator';
import Business from '../models/Business';
import AnOverline from './AnOverline.vue';

@Component({ components: { AnOverline } })
export default class extends Vue {
  @Prop(Object) readonly business!: Business;

  @Prop(Boolean) readonly forceQuote!: boolean;

  @Prop(Boolean) readonly centered!: boolean;

  get localized(): HashAny {
    return this.business?.locale || {};
  }

  get kspHtml() {
    if (this.business?.kspText) {
      return markdown(this.business.kspText);
    }
    return '';
  }
}
